import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { OptionsService } from 'src/app/service/options.service';
import { Options } from 'src/app/model/options';
import { OPTIONS } from 'src/app/data/options';
import { CanvasStateService } from 'src/app/service/canvas-state.service';
import { CanvasOptionsService } from 'src/app/service/canvas-options.service';
import { ElementsService } from 'src/app/service/elements.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-options-menu',
  templateUrl: './options-menu.component.html',
  styleUrls: ['./options-menu.component.less']
})
export class OptionsMenuComponent implements OnInit {
  subscription: Subscription;
  options: Options[];

  properties:boolean = false;
  zones:boolean = false;
  products:boolean = false;
  contour:boolean = false;

  @ViewChild('warning') warningElement:ElementRef;
  
  constructor(
      private optionsService: OptionsService,
      public canvasState: CanvasStateService,
      private canvasOptionsService: CanvasOptionsService,
      private modalService: NgbModal,      
      private elementsService:ElementsService
  ) { }

  ngOnInit() {

      this.options=OPTIONS;
      this.subscription = this.optionsService.options$.subscribe(data => {
        this.options = data;
        let active=this.optionsService.active;
        let action=active.staticName;
        if(action=="PROPERTIES")
          this.properties=active.active;
        else
          this.properties=false;

        if(action=="ZONE-ROOF")
          this.zones=active.active;
        else
          this.zones=false;

        if(action=="ZONE-ROOF-ADD")
          this.zones=true;

        if(action=="DRAW-CONTOUR")
          this.contour=active.active;
        else
          this.contour=false;

        if(action=="PRODUCTS")
          this.products=active.active;
        else
          this.products=false;
      });
     
  }

  toggleAction(action: string){
    let activeAction=this.optionsService.active?this.optionsService.active.staticName:null;
    if(activeAction=='ZONE-ROOF' || activeAction=='ZONE-ROOF-ADD' || activeAction=='ZONE-ROOF-EDIT'){
      if(action=='PROPERTIES' || action=='PRODUCTS'){
        let deleted=this.elementsService.clearInvalidZones();
        let closed=this.elementsService.checkIfShapesClosed();        

        if(!closed){          
          this.setBackgroundModal();
          return false;
        }
      }
    }else if(activeAction=='DRAW-CONTOUR'){
      if(action=='PROPERTIES' || action=='PRODUCTS' || 'ZONE-ROOF'){
        let deleted=this.elementsService.clearInvalidZones();
        let closed=this.elementsService.checkIfShapesClosed();
        if(!closed){          
          this.setBackgroundModal();
          return false;
        }
      }
    }
    let active=this.optionsService.toggleAction(action);
  }

  setBackgroundModal(){
    this.modalService.open(this.warningElement, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  changeActiveOption(name: string) {
        this.optionsService.changeOptionsState(name);
  }
  changeActiveSubOption(name: string) {    
      this.optionsService.changeSubOptionsState(name);
  }


}
